import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PhoneIcon from '@material-ui/icons/Phone';
import FavoriteIcon from '@material-ui/icons/Favorite';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import Home from '@material-ui/icons/Home';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import ThumbDown from '@material-ui/icons/ThumbDown';
import Typography from '@material-ui/core/Typography';
import BasicCustomerProfile from '../Customer/BasicCustomerProfile.jsx';
import AddressList from '../Customer/AddressList.jsx';
import CustomerBookingList from '../Customer/CustomerBookingList';
import ProviderBookingList from '../Providers/ProviderBookingList.jsx';
import ProviderBusinessHours from '../Providers/ProviderBusinessHours.jsx';
import CustomerFavoriteList from '../Customer/CustomerFavoriteList';
import CustomerWalletList from '../Customer/CustomerWalletList.jsx';
import CustomerTransactionList from '../Customer/CustomerTransactionList.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ROLE_CUSTOMER, ROLE_PROVIDER } from '../../utils/config/constants.js';
import { Dashboard, AccountBalance, AccountBalanceWallet,  HomeOutlined } from '@material-ui/icons';
import ProviderTrainingCenter from '../Providers/ProviderTrainingCenter.jsx';
import EarningsListScreenNew from '../../views/ProviderScreensNew/EarningsListScreenNew.jsx';
function TabContainer(props) {
    return (
        <Typography component="div" style={{ paddingTop: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired
};

const styles = theme => ({
    root: {
        flexGrow: 1,
        marginTop: '10px',
        width: '100%',
        backgroundColor: theme.palette.background.paper
    }
});

class CustomerTab extends React.Component {
    

    constructor(props) {
        console.log("qqqqqqqqqqqqqqqqqqqqqqqqq",props)
        super(props);
        const initialValue = props.history.location.state && props.history.location.state.value;
        const loginPath = props.history.location.state && props.history.location.state.loginPath;

        this.state = {
            value: initialValue === 3 ? 3 : (initialValue === 2 ? 2 : (initialValue === 1 ? 1 : 0)),
            loginpath: loginPath,
            customerRedirect: false,
        };
    }


    // state = {
    //     value: 0
    // };

    handleChange = (event, value) => {
        this.setState({ value });
    };

    render() {
        const { classes, userData } = this.props;
        const { formatMessage } = this.props.intl;
        const { value } = this.state;
        const {state} = this.props
        console.log(value);
        console.log(this.props);
        console.log("60value", state);
        return (
            <div className={classes.root}>
                <AppBar
                    position="static"
                    color="default"
                    className="profiles-tabs"
                >
                    <Tabs
                        value={value}
                        onChange={this.handleChange}
                        variant="scrollable"
                        scrollButtons="on"
                        indicatorColor="primary"
                        textColor="primary"
                        centered
                        id="scolling_btn"
                    >
                        <Tab
                            label={formatMessage({
                                id: 'customer.basicprofile'
                            })}
                            icon={<PhoneIcon />}
                        />
                        {/* <Tab
                            label={formatMessage({
                                id: 'customer.addresses'
                            })}
                            icon={<Home />}
                        />
                        <Tab
                            label={formatMessage({
                                id: 'customer.bookings'
                            })}
                            icon={<PersonPinIcon />}
                        /> */}

                        {/* <Tab
                            label={formatMessage({
                                id: 'customer.businessHour'
                            })}
                            icon={<Dashboard />}
                        /> */}
                        <Tab
                            label={formatMessage({
                                id: 'customer.trainingcenter'
                            })}
                            icon={<AccountBalance />}
                        />
                        <Tab
                            label={"Addresses"}
                            icon={<Home />}
                        />
                        <Tab
                            label={"Earnings"}
                            icon={<AccountBalanceWallet />}
                        />
                    </Tabs>
                </AppBar>
                {value === 0 && (
                    <TabContainer>
                        {/* <h3>PROVIDER TABSSS</h3> */}
                        <BasicCustomerProfile {...this.props} />
                    </TabContainer>
                )}
                {/* {value === 1 && (
                    <TabContainer>
                        <AddressList {...this.props} />
                    </TabContainer>
                )}
                {value === 2 && (
                    <TabContainer>
                        <ProviderBookingList {...this.props} />
                    </TabContainer>
                )} */}
                {/* {value === 1 && userData.role == ROLE_PROVIDER && (
                    <TabContainer>
                        <ProviderBusinessHours {...this.props} />
                    </TabContainer>
                )} */}
                {value === 1 && userData.role == ROLE_PROVIDER && (
                    <TabContainer>
                        <ProviderTrainingCenter {...this.props} />
                    </TabContainer>
                )}
                {value === 2 && (
                    <TabContainer>
                        <AddressList {...this.props} />
                    </TabContainer>
                )}
                {value === 3  && (
                    <TabContainer>
                        <EarningsListScreenNew {...this.props} />
                    </TabContainer>
                )}
            </div>
        );
    }
}

CustomerTab.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(injectIntl(CustomerTab));



// WEBPACK FOOTER //
// ./src/components/Tabs/ProviderTabs.jsx